// extracted by mini-css-extract-plugin
export default {"layout":"compass_layout__2+-il"};